export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_12-EN-0f079bb303820ff7b56134074825914b.webp";